export default __webpack_public_path__ + "static/media/cylindersFive.1f1f5857.png";